import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Spinner, TabContent, TabType, Tabs } from '@it-incubator/ui-kit'
import { skipToken } from '@reduxjs/toolkit/query'
import { useRemoveHashFromUrl } from 'common/hooks'
import { NoteType, useGetMDXContentQuery, useGetVideoByIdQuery } from 'features/videos/service'

import { Comments } from '../comments/Comments'
import { MDXContent } from './MDXContent'

export const VideoTabs = () => {
  const [activeTab, setActiveTab] = useState<string>('comments')
  const { videoId } = useParams<{ videoId: string }>()
  const removeHash = useRemoveHashFromUrl()

  // const { data: mdxMain, isLoading: isMdxMainLoading } = useGetVideoMDXMainQuery(videoId ?? '')
  const { data: video, isLoading: isVideoLoading } = useGetVideoByIdQuery(
    { id: videoId ?? '' },
    {
      refetchOnMountOrArgChange: false,
    }
  )

  const mainMdxNote = video?.mdxNotes.find(note => note.type === NoteType.Main)
  const previewMdxNote = video?.mdxNotes.find(note => note.type === NoteType.Preview)
  const mdxPath = mainMdxNote?.mdxFilePath || previewMdxNote?.mdxFilePath
  const { data: mdx, isLoading: isMdxMainLoading } = useGetMDXContentQuery(
    mdxPath ? { path: encodeURIComponent(mdxPath) } : skipToken
  )

  console.log(mdx)

  const TABS: TabType[] = [
    {
      disabled: !mdx,
      title: 'Конспект',
      value: 'mdx-notes',
    },
    {
      disabled: false,
      title: `Комментарии (${video?.comments?.length ?? 0})`,
      value: 'comments',
    },
  ]

  useEffect(() => {
    if (mdx) {
      setActiveTab(TABS[0].value)
    } else {
      setActiveTab(TABS[1].value)
    }
  }, [mdx])

  if (isMdxMainLoading || isVideoLoading) {
    return <Spinner />
  }

  return (
    <Tabs
      fullWidth
      onValueChange={value => {
        setActiveTab(value)
        removeHash()
      }}
      tabs={TABS}
      value={activeTab}
    >
      <TabContent value={TABS[0].value}>
        {mdx && <MDXContent code={mdx.code} tocMap={mdx.toc.map} />}
      </TabContent>
      <TabContent value={TABS[1].value}>
        <Comments videoComments={video?.comments} />
      </TabContent>
    </Tabs>
  )
}
